/** Display formatting for the usage/cost surface. Pure, so it's unit-tested. */

const EN = 'en';

/** Whole-number counts with thousands separators: 1,234. */
export function count(n: number): string {
  return Math.round(Number.isFinite(n) ? n : 0).toLocaleString(EN);
}

/** Compact magnitudes for tight stat tiles: 1.2k, 3.4M, 0.9B. */
export function compact(n: number): string {
  const v = Number.isFinite(n) ? n : 0;
  const abs = Math.abs(v);
  if (abs >= 1e9) return `${(v / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(v / 1e3).toFixed(1)}k`;
  return String(Math.round(v));
}

/**
 * USD with enough precision to be honest about sub-cent spend: metered calls
 * routinely cost a fraction of a cent, so only collapse to whole cents once the
 * figure is meaningful (>= $0.01).
 */
export function usd(n: number): string {
  const v = Number.isFinite(n) ? n : 0;
  if (v > 0 && v < 0.01) return `$${v.toFixed(4)}`;
  return `$${v.toFixed(2)}`;
}
